<template>
  <div class="base64">
    <div :class="['upload-cont', btnClass]">
      {{ $t("imageToBase64.uploadImage") }}
      <input
        type="file"
        :multiple="multiple"
        class="base64-upload"
        @change="onChange"
      />
    </div>
    <img
      v-show="myPreview && previewImage"
      :src="myPreview"
      class="base64-image"
      alt="uploaded image"
    />
  </div>
</template>

<script>
export default {
  name: "image-to-base64",
  props: {
    preview: "", //Image uri
    accept: {
      // Image type
      type: String,
      default: "image/png, image/png",
    },
    previewImage: {
      // To show image
      type: Boolean,
      default: true,
    },
    maxSize: {
      // Image size limit
      type: Number,
      default: 5,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    btnClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      myPreview: null,
    };
  },
  methods: {
    onChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      // Possibility to download a single or several files
      const file = files[0],
        M = 1024 * 1024,
        size = file.size / M,
        reg = /\/(jpg|png|jpeg)+$/i,
        reader = new FileReader();
      let fileInfo = {};

      if (!reg.test(file.type)) {
        this.$emit("type-error", file.type);
        return;
      }

      if (size > this.maxSize) {
        this.$emit("size-error", size);
        return;
      }
      
      reader.onload = (e) => {
        const dataURI = e.target.result;
        if (dataURI) {
          fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size / 1000) + " kB",
            base64: dataURI,
            file: file,
          };
          this.$emit("file-info", fileInfo);
          this.myPreview = dataURI;
        }
      };
      reader.readAsDataURL(file);
    },
  },
  watch: {
    previewImage(v) {
      this.previewImage = v;
    },
    myPreview(v) {
      this.myPreview = v;
    },
    preview(v) {
      this.myPreview = v;
    },
  },
  created() {
    if (this.preview != "") {
      this.myPreview = this.preview;
    }
  },
};
</script>

<style lang="scss" scoped>
.base64 {
  cursor: pointer;

  .upload-cont {
    position: relative;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
    overflow: hidden;
    > input[type="file"] {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }
  .base64-image {
    margin-top: 20px;
    width: 100px;
  }
}
</style>
